import React, { createContext, Suspense, useEffect, useState } from "react";
import ValvePilot from "./components/ValvePilot/ValvePilot";
import { ThemeProvider } from "@mui/material";
import { valvePilotTheme } from "./theme/valvePilotTheme";

import { v4 as uuidv4 } from "uuid";

import { matomoTracker } from "./tools/matomo";

type language = {
  [key: string]: string;
};

interface ConfigContextProps {
  proxyUrl: string;
  apiVersion: string;
  configuratorUrl: string;
  fractionDigits: number;
  languages: language[];
}

export const ConfigContext = createContext<ConfigContextProps|undefined>({
    proxyUrl: '',
    apiVersion: '',
    configuratorUrl: '',
    fractionDigits: 3,
    languages: []
})

function App () {
  const [config, setConfig] = useState<ConfigContextProps>();

  useEffect(() => {
    fetch("./config.json").then((res) => {
        return res.json()
      }).then((config) => {
        if(config) {
            setConfig(config);
        }
      });
    const packageJson = require('../package.json');
    console.log('Version:', packageJson.version, ' testing');
  }, []);

  useEffect(() => {
    const setCorrelationId = () => {
      let correlationId = sessionStorage.getItem("correlationId");
      if (!correlationId) {
        correlationId = uuidv4();
        sessionStorage.setItem("correlationId", correlationId);
      }
      return correlationId;
    };
    setCorrelationId();
  }, []);

  useEffect(() => {
    const correlationId = sessionStorage.getItem("correlationId");
    matomoTracker.trackPageView({
      documentTitle: document.title,
      href: window.location.href,
    });
    matomoTracker.pushInstruction('setUserId', correlationId);

  }, [window.location]);

    return (
        <Suspense>
            <ThemeProvider theme={valvePilotTheme}>
                <ConfigContext.Provider value={config}>
                    {config && <ValvePilot sx={{marginY: 3, maxWidth: 1569}} showIconButtons/>}
                    {/*<ValvePilotDynamic data={tableData} sx={{marginTop: 3}}/>*/}
                </ConfigContext.Provider>
            </ThemeProvider>
        </Suspense>
    );
}

export default App;
